import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from './createBaseQuery';

export interface IFeatureFlag {
  name: string;
  isActive: boolean;
  id: string;
}

export interface IFeatureFlagsResponse {
  [key: string]: boolean;
}

export interface ICreateFeatureFlagRequest {
  name: string;
  isActive: boolean;
}

export interface IUpdateFeatureFlagRequest {
  name: string;
  isActive: boolean;
}

export const featureFlagsApi = createApi({
  reducerPath: 'featureFlagsApi',
  baseQuery: createBaseQuery(),
  tagTypes: ['FeatureFlags'],
  endpoints: (builder) => ({
    getFeatureFlags: builder.query<IFeatureFlag[], void>({
      query: () => ({
        url: '/feature-flags',
        method: 'GET',
      }),
      transformResponse: (baseQueryReturnValue: { [key: string]: boolean }) =>
        Object.entries(baseQueryReturnValue).map(([name, isActive]) => ({
          name,
          isActive,
          id: name,
        })),
      providesTags: ['FeatureFlags'],
    }),
    getAdminFeatureFlags: builder.query<IFeatureFlag[], void>({
      query: () => ({
        url: '/admin/feature-flags',
        method: 'GET',
      }),
      providesTags: ['FeatureFlags'],
    }),
    createFeatureFlag: builder.mutation<IFeatureFlag, ICreateFeatureFlagRequest>({
      query: (body) => ({
        url: '/admin/feature-flags',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['FeatureFlags'],
    }),
    updateFeatureFlag: builder.mutation<IFeatureFlag, { id: string; body: IUpdateFeatureFlagRequest }>({
      query: ({ id, body }) => ({
        url: `/admin/feature-flags/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['FeatureFlags'],
    }),
    deleteFeatureFlag: builder.mutation<void, string>({
      query: (id) => ({
        url: `/admin/feature-flags/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['FeatureFlags'],
    }),
  }),
});

export const {
  useGetFeatureFlagsQuery,
  useGetAdminFeatureFlagsQuery,
  useCreateFeatureFlagMutation,
  useUpdateFeatureFlagMutation,
  useDeleteFeatureFlagMutation,
} = featureFlagsApi; 